export enum AccessLevel {
    None = 0,
    Guest = 1,
    Tester = 2,
    Admin = 3
}